export default __webpack_public_path__ + "static/media/left_top.7c525bee.png";